<template>
  <svg class="loading-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <title>Loading spinner icon</title>
    <circle cx="50" cy="50" r="41" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'LoadingSpinner',
};
</script>
